import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import * as XLSX from 'xlsx';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import { Listoftablesearchbox1, SearchBox, getRetrievedBDMData, getRetrievedDEMData, getModifiedBDMData, getModifiedDEMData } from "../components/Propertyfile";
import { Makerpastmodifylist, Makerretrievalmodifylist, pastdatadelete, previewrdmdata, updatetextfile3001, modifypastdata, makermodifypastdata } from '../components/ApiProperty';
import { TableRetrievalListGapsy, ListofTableFontsize, PaginationComponentForm2, TemplatetablelistTableStructure, TemplatetablelistTableStructure1 } from "../components/TableProperty";
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { useSession } from '../components/SessionContext';

const GapsyApproveTablelist = () => {
    const [activeTab, setActiveTab] = useState('manual'); // 'manual' or 'ai'
    const [tableColumns, setTableColumns] = useState([]);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [deleteRowIndex, setDeleteRowIndex] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editingIndexBDm, setEditingIndexBDm] = useState(null);
    const [primaryKeyFields, setPrimaryKeyFields] = useState([]);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [notificationType, setNotificationType] = useState('IN');
    const [formStructure, setFormStructure] = useState(null);
    const [selectedDownloadFormat, setSelectedDownloadFormat] = useState(null); // Store selected format
    const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const location = useLocation();
    const [modalMessage, setModalMessage] = useState('');
    const [notifyType, setNotifyType] = useState('IN'); // Set EOD as default
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [selectedName, setSelectedName] = useState('');
    const [tableNames, setTableNames] = useState([]);
    const [dataModel, setDataModel] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(5);

    const [currentPage1, setCurrentPage1] = useState(1);
    const [recordsPerPage1] = useState(5); // Set the number of records per page

    const [modalMessageOne, setModalMessageOne] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames || {});
    const [showPastTablesOnly, setShowPastTablesOnly] = useState(false);
    const [showSheetSelection, setShowSheetSelection] = useState(false);
    const [selectedSheet, setSelectedSheet] = useState(null);
    const [Prefix, setPrefix] = useState("");
    const [selectedFullTableName, setSelectedFullTableName] = useState('');
    const [selectedtableName, setSelectedtableName] = useState('');
    const [isLiveTable, setisLiveTable] = useState('');

    const [sheetSelectionModal, setSheetSelectionModal] = useState({
        show: false,
        sheets: [],
        selectedSheets: [],
        workbook: null,
        file: null,
    });
    const [selectedFileName, setSelectedFileName] = useState('');

    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [columnsToDisplay, setColumnsToDisplay] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedDate, setSelectedDate] = useState('');

    const department = sessionStorage.getItem("dept");
    const [rowIdToEdit, setRowIdToEdit] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showConfirmApproveModal, setShowConfirmApproveModal] = useState(false);
    const [rowIdToDelete, setRowIdToDelete] = useState(null);
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const param = selectedtableName;
    const [hasAutoPreviewed, setHasAutoPreviewed] = useState(false);
    const [reportingDate, setReportingDate] = useState("");
    const [reportingFilteredData, setReportingFilteredData] = useState([]);
    const { sessionId } = useSession();
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('param');
        setParam(paramValue); // This sets it in state
    }, []);

    const formatTableNameForSearch = (tableName) => {
        const [_, ...rest] = tableName.split('_'); // remove prefix like "Finance"
        return rest.join(' ').replace(/_/g, ' ').toLowerCase().trim();
    };



    useEffect(() => {
        const navigatedFromDashboard = localStorage.getItem('navigatedFromDashboard');

        if (!navigatedFromDashboard) return;

        const storedDept = localStorage.getItem('selectedDept');
        const storedTable = localStorage.getItem('selectedTable');
        const storedDataModel = localStorage.getItem('selectedDataModel');

        if (storedDataModel && storedTable) {
            setShowDropdown(false);
            setSelectedDownloadFormat(null);
            const targetTab = storedDataModel === 'DEM' ? 'manual' : 'bulkUpload';
            setActiveTab(targetTab);
            setDataModel(storedDataModel);

            if (storedDept) {
                setSelectedPrefix(storedDept);
            }

            const [prefix, ...rest] = storedTable.split('_');
            const tableNameWithoutPrefix = rest.join('_');

            setSearchQuery(formatTableNameForSearch(storedTable));
            setSelectedFullTableName(storedTable);
            setShowPastTablesOnly(true); //  Always true from dashboard

            setTimeout(() => {
                handleTableClick({ name: storedTable, isPast: true }, targetTab);
                setSelectedtableName(storedTable);
            }, 100);

            setHasAutoPreviewed(true);
        }


    }, []);


    useEffect(() => {
        const navigatedFromDashboard = localStorage.getItem('navigatedFromDashboard');

        if (navigatedFromDashboard) {
            //  Your auto-preview logic here
            const selectedDept = localStorage.getItem('selectedDept');
            const selectedTable = localStorage.getItem('selectedTable');
            const selectedDataModel = localStorage.getItem('selectedDataModel');

            if (selectedDept && selectedTable && selectedDataModel) {
                //  Trigger preview based on those values
                handleTableClick(selectedTable); // or whatever method you use
            }

            //  Clear the flag after acting on it
            localStorage.removeItem('navigatedFromDashboard');
        }
    }, []);



    let prefix = '';
    if (param) {
        prefix = param.split('_')[0];
    } else {
        console.warn('URL param "param" is missing');
        // Optionally handle the error more gracefully, like:
        // showMessageModal("Missing parameter in URL", "error");
    }

    const [tableData, setTableData] = useState([]);
    const [tableDataflag, setTableDataflag] = useState([]);
    const [paramState, setParam] = useState('');
    const [contacts, setContacts] = useState([]);

    const textFileFormats = ["csv", "xlsx", "txt"];

    const handleFormatSelect = (format) => {
        setSelectedDownloadFormat(format); // Store selected format
        setShowDropdown(false); // Close dropdown after selection
    };

    const handleTogglePastTables = (e) => {
        const checked = e.target.checked;
        setShowPastTablesOnly(checked);

        setSelectedFullTableName(null);
        setSelectedtableName(null);
        setPrefix(null);
        setSelectedName(null);
        setFormStructure([]);
        setvalidErrorRecords([]);
        setTableData([]);             // Clear displayed table data
        setTableDataflag([]);         // Clear flag-based raw data
        setColumnsToDisplay([]);      // Clear displayed columns
        setTableColumns([]);          // Clear table structure
        setReportingFilteredData([]); // Clear filtered data
        setError(null);
        setSearchTerm('');
        setRecordsPerPage(5); // or your default value
        setCurrentPage(1);
    };

    useEffect(() => {
        fetchData();
    }, [activeTab, showPastTablesOnly]);





    const indexOfLastItem = currentPage * recordsPerPage;
    const indexOfFirstItem = indexOfLastItem - recordsPerPage;

    const formatDate = (inputDate) => {
        if (!inputDate) return "";
        const date = new Date(inputDate);
        return date.toISOString().split("T")[0]; // '2024-07-31'
    };


    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const paginate1 = (pageNumber) => {
        setCurrentPage1(pageNumber);
    };
    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };




    const fetchFormStructureAndData = async (tableName, tabKey = activeTab, isPast = false) => {
        try {
            setLoading(true);
            const urlParams = new URLSearchParams(window.location.search);
            const paramValue = urlParams.get('param');
            setParam(paramValue);

            // const formResponse = await fetch(`${PortURL}/demformtemplate/${tableName}.json`);
            const formResponse = await fetch(`/demformtemplate/${tableName}.json`);
            if (!formResponse.ok) throw new Error('Nothing pending for Modification');

            const formStructure = await formResponse.json();
            setFormStructure(formStructure);

            const initialFormData = {};
            if (Array.isArray(formStructure.details)) {
                formStructure.details.forEach(detail => {
                    if (detail.columnActive === "N") {
                        if (detail.columnKey === "" || detail.columnKey?.toLowerCase() === "null" || detail.columnKey?.toLowerCase() === "not null") {
                            switch (detail.columnType.toUpperCase()) {
                                case 'INT':
                                case 'INTEGER':
                                    initialFormData[detail.columnName] = 0;
                                    break;
                                case 'VARCHAR':
                                case 'CHAR':
                                case 'TEXT':
                                    initialFormData[detail.columnName] = 'N';
                                    break;
                                case 'DATE':
                                    initialFormData[detail.columnName] = '1900-01-01';
                                    break;
                                default:
                                    initialFormData[detail.columnName] = null;
                            }
                        }
                    }
                    initialFormData[detail.columnName] = '';
                });
            } else {
                throw new Error('Form structure is not an array.');
            }

            const activeColumns = formStructure.details
                .filter(detail => detail.columnActive !== "N")
                .map(detail => detail.columnName);

            // Add manually if not present
            if (!activeColumns.includes("reporting_date")) {
                activeColumns.push("reporting_date");
            }

            const requiredColumns = ["Maker_Remarks"];
            requiredColumns.forEach(col => {
                if (!activeColumns.includes(col)) {
                    activeColumns.push(col);
                }
            });
            const primaryKeyFields = formStructure.details
                .filter(detail => detail.columnKey === 'PRIMARY KEY')
                .map(detail => detail.columnName);

            setPrimaryKeyFields(primaryKeyFields); // <-- store this in state

            const dataModel = tabKey === 'manual' ? 'DEM' : 'BDM';
            const tableSuffix = isPast ? '_retrieved' : '_live';
            // const fullTableName = `${tableName}${tableSuffix}`;
            const fullTableName = tableName.endsWith('_retrieved') || tableName.endsWith('_live')
                ? tableName
                : `${tableName}${tableSuffix}`;
            // setisLiveTable(fullTableName);
            setisLiveTable(fullTableName.endsWith('_live'));



            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                params: {
                    tableName: fullTableName,
                    dataModel: dataModel
                },
                withCredentials: true,
            };

            const apiResponse = await axios.post(previewrdmdata, {}, config);

            if (apiResponse.data?.fileName) {
                //  const tableResponse = await fetch(`${PortURL}/jsonfiles/${fullTableName}.json`);
                const tableResponse = await fetch(`/jsonfiles/${fullTableName}.json`);
                if (!tableResponse.ok) throw new Error('Error fetching table data');

                const rawData = await tableResponse.json();
                setTableDataflag(rawData);

                // let filteredData = dataModel === 'BDM'
                //     ? getModifiedBDMData(rawData, activeColumns, search, selectedDate)
                //     : getModifiedDEMData(rawData, activeColumns, search, selectedDate);

                let filteredData;

                if (isPast) {
                    // For _retrieved (past), use getModified
                    filteredData = dataModel === 'BDM'
                        ? getModifiedBDMData(rawData, activeColumns, search, selectedDate)
                        : getModifiedDEMData(rawData, activeColumns, search, selectedDate);
                } else {
                    // For _live, use getRetrieved
                    filteredData = dataModel === 'BDM'
                        ? getRetrievedBDMData(rawData, activeColumns, search, selectedDate)
                        : getRetrievedDEMData(rawData, activeColumns, search, selectedDate);
                }


                // if (rawData.length > 0 && 'Rejected_Reason' in rawData[0] && !activeColumns.includes('Rejected_Reason')) {
                //     activeColumns.push('Rejected_Reason');
                // }

                if (rawData.length > 0) {
                    if ('Rejected_Reason' in rawData[0] && !activeColumns.includes('Rejected_Reason')) {
                        activeColumns.push('Rejected_Reason');
                    }

                    if ('Maker_Remarks' in rawData[0] && !activeColumns.includes('Maker_Remarks')) {
                        activeColumns.push('Maker_Remarks');
                    }
                }

                setColumnsToDisplay(activeColumns);
                setTableColumns(activeColumns);
                setTableData(filteredData);
                setReportingFilteredData(filteredData);
                console.log("Filtered table data preview:", filteredData.slice(0, 3));
                console.log("Selected Date:", selectedDate);
                // console.log("First Row Date:", formatDate(filteredData[0]?.reporting_date));
                if (filteredData.length > 0) {
                    console.log("First Row Date:", formatDate(filteredData[0].reporting_date));
                }

                setCurrentPage(1); // reset to first page
            } else {
                throw new Error('No data available for modification');
            }

        } catch (error) {
            console.error("Error:", error.message);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (rowId) => {
        setRowIdToEdit(rowId);
        setShowEditModal(true);
    };
    const handleEditBDM = (rowId) => {
        setEditingIndexBDm(rowId);
    };

    const handleInputChange = (e, key, index) => {
        const newValue = e.target.value;
        const updatedData = [...tableData];
        updatedData[index][key] = newValue;
        setTableData(updatedData);
    };


    const handleDelete = (rowId) => {
        setRowIdToDelete(rowId);
        setShowConfirmApproveModal(true);
    };

    const handleDelete1 = (rowId) => {
        setRowIdToDelete(rowId);
        setShowConfirmDeleteModal(true);
    };



    const confirmEdit = () => {
        if (rowIdToEdit !== null) {
            const isPast = selectedFullTableName?.endsWith('_retrieved');
            const targetPage = isPast ? 'gapsyModifypastdata' : 'gapsyEditpastdata';

            navigate(`/${targetPage}?param=${param}&&file=${param}.json&&rowIndex=${rowIdToEdit}`);
            setShowEditModal(false);
        } else {
            console.error('No row ID to edit.');
        }
    };


    const confirmDelete = async () => {
        try {

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { "tableName": selectedName, "dataModel": "DEM", "rowId": rowIdToDelete, "dept": Prefix }
            };

            // const response = await axios.post('http://172.16.119.156:8081/api/deletedata/dem', data, config);
            const response = await axios.post(pastdatadelete, {}, config);

            if (response.data && response.data.active_status && response.data.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: response.data.active_status,
                    template_type: response.data.template_type,
                    stage: response.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }
            if (response.data && response.data.message === 'Data Deleted Successfully' || 'Past Data Deleted Successfully') {
                setModalMessage(`1 record of <strong>${toTitleCase(selectedName)}</strong> Deleted Successfully`);
                setMessageType('success');
                setShowConfirmApproveModal(false);
                setShowModal(true);
            } else {
                setModalMessage(response.data.message); // Replace with your success message
                setShowConfirmApproveModal(false);
                setMessageType('danger');
                setShowModal(true);
            }

            const updatedTableData = tableData.filter(item => item.rowId !== rowIdToDelete);
            setTableData(updatedTableData);
            setData(updatedTableData);

        } catch (error) {
            console.error('Error deleting data:', error.message);
            setModalMessage('Error deleting data', 'error'); // Show error modal in red
            setMessageType('danger');

        } finally {
            setShowConfirmApproveModal(false);
        }
    };

    const confirmDelete1 = async () => {
        try {

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { "tableName": selectedName, "dataModel": "BDM", "rowId": rowIdToDelete, "dept": Prefix }
            };

            // const response = await axios.post('http://172.16.119.156:8081/api/deletedata/dem', data, config);
            const response = await axios.post(pastdatadelete, {}, config);

            if (response.data && response.data.active_status && response.data.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: response.data.active_status,
                    template_type: response.data.template_type,
                    stage: response.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }
            // if (response.data && response.data.message === 'Data Deleted Successfully' || 'Past Data Deleted Successfully') {
            if (
                response.data &&
                (response.data.message === 'Data Deleted Successfully' ||
                    response.data.message === 'Past Data Deleted Successfully')
            ) {
                setModalMessage(`1 record of <strong>${toTitleCase(selectedName)}</strong> Deleted Successfully`);
                setMessageType('success');
                setShowConfirmDeleteModal(false);
                setShowModal(true);
            } else {
                setModalMessage(response.data.message); // Replace with your success message
                setShowConfirmDeleteModal(false);
                setShowModal(true);
                setMessageType('danger');
            }

            const updatedTableData = tableData.filter(item => item.rowId !== rowIdToDelete);
            setTableData(updatedTableData);
            setData(updatedTableData);

        } catch (error) {
            console.error('Error deleting data:', error.message);
            setModalMessage('Error deleting data', 'error'); // Show error modal in red
            setMessageType('danger');

        } finally {
            setShowConfirmDeleteModal(false);
        }
    };


    const fetchData = async (tabKey = activeTab) => {
        setvalidErrorRecords([]);
        try {
            const config = {
                headers: { userId: localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                params: {
                    dept: sessionStorage.getItem("dept"),
                    dataModel: tabKey === 'manual' ? 'DEM' : 'BDM'
                },
                withCredentials: true,
            };

            const config1 = {
                headers: { userId: localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                params: {
                    dept: sessionStorage.getItem("dept"),
                    dataModel: tabKey === 'manual' ? 'DEM' : 'BDM',
                    tabletype: 'retrieved'
                },
                withCredentials: true,
            };

            let retrievalRes = { data: { tableList: [] } };
            let pastRes = { data: { tableList: [] } };

            if (showPastTablesOnly) {
                pastRes = await axios.post(Makerpastmodifylist, {}, config1);
            } else {
                retrievalRes = await axios.post(Makerretrievalmodifylist, {}, config);
            }

            const processTableList = (tableList = [], isPast = false) => {
                const categorizedTables = {};
                tableList.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push({ name: table, isPast }); // include flag
                });
                return categorizedTables;
            };

            const allTables = [
                ...(retrievalRes.data?.tableList || []),
                ...(pastRes.data?.tableList || [])
            ];

            if (allTables.length > 0) {
                // const categorized = processTableList(allTables);
                const retrievedCategorized = processTableList(retrievalRes.data?.tableList, false);
                const pastCategorized = processTableList(pastRes.data?.tableList, true);

                // Merge retrieved + past lists per prefix
                const combinedCategorized = { ...retrievedCategorized };
                for (const prefix in pastCategorized) {
                    if (!combinedCategorized[prefix]) {
                        combinedCategorized[prefix] = [];
                    }
                    combinedCategorized[prefix].push(...pastCategorized[prefix]);
                }

                setTableNames(combinedCategorized); // shape: { HR: [ {name: 'HR_table1', isPast: true}, ... ] }
                // const flatList = Object.values(combinedCategorized).flat();
                // setAllTableList(flatList); // This will store the flat array in state

                // setTableNames(categorized);
            } else {
                setTableNames({});
                const dept = sessionStorage.getItem("dept") || "Department not found";
                // optionally show message
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setTableNames({});
        }
    };


    const filteredData = reportingFilteredData.filter(item =>
        (!selectedDate || formatDate(item.reporting_date) === selectedDate) &&
        columnsToDisplay.some(column =>
            item[column]?.toString().toLowerCase().includes(searchTerm)
        )
    );

    // Pagination index
    const indexOfLastItem1 = currentPage * recordsPerPage;
    const indexOfFirstItem1 = indexOfLastItem1 - recordsPerPage;

    // Apply pagination if more than 5 records
    const currentItems = filteredData.length > 5
        ? filteredData.slice(indexOfFirstItem1, indexOfLastItem1)
        : filteredData;

    // Total pages for pagination component
    const totalPages2 = Math.ceil(filteredData.length / recordsPerPage);


    const handleTableClick = async (item, tabKey = activeTab) => {
        try {
            const name = typeof item === 'string' ? item : item?.name;
            const isPast = showPastTablesOnly || (typeof item === 'object' && item?.isPast);  // ✅ Force _retrieved if checkbox is selected

            if (!name || !name.includes('_')) {
                throw new Error("Invalid table name format");
            }

            const [prefix, ...restParts] = name.split('_');
            const selectedName = restParts.join('_');

            setPrefix(prefix);
            setSelectedName(selectedName);
            setvalidErrorRecords([]);
            setSelectedtableName(name);

            const suffix = isPast ? '_retrieved' : '_live';
            const fullTableNameWithSuffix = `${name}${suffix}`;
            setSelectedFullTableName(fullTableNameWithSuffix);

            // await fetchFormStructureAndData(name, tabKey, isPast); // ✅ use updated isPast
            const baseTableName = name.endsWith('_retrieved') || name.endsWith('_live')
                ? name.replace(/_(retrieved|live)$/, '')
                : name;

            await fetchFormStructureAndData(baseTableName, tabKey, isPast);

        } catch (error) {
            console.error("Table click error:", error);
            setModalMessageOne(error.message || "Failed to load table data");
        }
    };




    useEffect(() => {
        setCurrentPage(1);
    }, [search, selectedDate]);


    const filteredRecords1 = useMemo(() => {
        if (!selectedPrefix || !tableNames || !tableNames[selectedPrefix]) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableObj) =>
            formatTableNameForSearch(tableObj.name).includes(query)
        );

    }, [tableNames, searchQuery, selectedPrefix]);


    useEffect(() => {
        setCurrentPage1(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage1(1);
    }, [selectedPrefix]);


    const sortedRecords1 = useMemo(() => {
        return [...filteredRecords1].sort((a, b) => {
            const aStarts = a.name.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.name.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts; // Prioritize items starting with the search query
        });
    }, [filteredRecords1, searchQuery]);

    const indexOfLastRecord1 = currentPage1 * recordsPerPage1;
    const indexOfFirstRecord1 = indexOfLastRecord1 - recordsPerPage1;
    const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord1, indexOfLastRecord1);

    const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);



    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPrefix]);

    const resetFormAndTableState = () => {
        setColumnsToDisplay([]);
        setTableData([]);
        setData([]);
        setContacts([]);
        setError('');
        setSearch('');
        setSelectedFile(null);
        setModalMessage('');
        setSelectedFileName(null);
        setSelectedSheet('');
        setShowPreview(false);
        setShowDownloadButton(false);
        setShowDropdown(false);
        setShowSheetSelection(false);
        setvalidErrorRecords([]);
        setTableNames({});
        setSelectedName('');
        setSelectedPrefix('');
        setSelectedFullTableName('');
        setShowPastTablesOnly(false);
        setPrefix('');
        setEditingIndex(null);
        setEditingIndexBDm(null);
        setDeleteRowIndex(null);
        setFormStructure(null);
        setMessageType('');
    };



    const handleCloseModal = () => {
        setModalMessage('');
        setMessageType('');

        const isPast = selectedFullTableName?.endsWith('_retrieved');
        const baseTableName = selectedFullTableName?.replace(/_(retrieved|live)$/, '');

        if (messageType === 'warning') return;

        if (messageType === 'danger') {
            fetchFormStructureAndData(baseTableName, activeTab, isPast);
            return;
        }

        if (selectedFullTableName && activeTab) {
            fetchFormStructureAndData(baseTableName, activeTab, isPast);
        }
    };


    const handleTabChange = (tabKey) => {
        resetFormAndTableState(); // no warning check here
        setActiveTab(tabKey);
        setShowPastTablesOnly(false);
        setSearchQuery('');
        // optionally comment this if you want to persist selection
        setSelectedName('');
        setSelectedPrefix('');
        setTableNames({});
        setSelectedDownloadFormat('');
        setSearchTerm('');
        setRecordsPerPage(5); // or your default value
        setCurrentPage(1);
        fetchData(tabKey);
        setSelectedtableName('');
        setSelectedFullTableName('');

    };

    const handleSearch = (event) => {
        const searchInput = event.target.value.trim().toLowerCase();
        setSearchTerm(searchInput);

        setCurrentPage(1); // Reset pagination to the first page on search
        // setSelectedRowIds([]); // Clear selections when searching

    };

    const handleSearchChange = (e) => {
        const input = e.target.value.trimStart();
        const normalizedInput = input.replace(/\s+/g, ' ').replace(/_/g, ' ');
        setSearchQuery(normalizedInput);

        const pageNumber = parseInt(input, 10);
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages1) {
            paginate1(pageNumber);
        }
    };


    const handleDashboard = () => {
        localStorage.removeItem('selectedDept');
        localStorage.removeItem('selectedTable');
        localStorage.removeItem('completedActivity');
        setSelectedPrefix('');
        setSearchQuery('');
        navigate('/gapsyMdashboard');
    };

    const showSearchInput = tableData.length > 0;

    const handleDeleteClick = (rowIndex) => {
        setDeleteRowIndex(rowIndex); // Set the row index to delete
        setShowConfirmDeleteModal(true); // Show the confirmation modal
    };

    const handleSave = async (rowIndex) => {
        const rowData = tableData[rowIndex];

        if (!formStructure) {
            console.error('Form structure not loaded yet.');
            return;
        }

        const invalidValues = ["", "0", "/N", "//N", "NULL", "\\N", null, undefined];

        // Get NOT NULL and PRIMARY KEY fields
        const mandatoryFields = formStructure.details.filter(detail => detail.columnKey === 'NOT NULL');
        const primaryKeyFields = formStructure.details.filter(detail => detail.columnKey === 'PRIMARY KEY');

        // Forcefully include Maker_Remarks as mandatory (but handle it separately)
        const allMandatoryFields = [...mandatoryFields];
        const makerRemarksField = {
            columnName: "Maker_Remarks",
            columnLabel: "Maker Remarks"
        };

        const missingMandatory = [];
        let isMakerRemarksMissing = false;

        for (const field of allMandatoryFields) {
            const value = rowData[field.columnName];
            if (invalidValues.includes(value?.toString().trim().toUpperCase())) {
                missingMandatory.push(field.columnLabel);
            }
        }

        // Validate Maker_Remarks separately
        const makerRemarksValue = rowData["Maker_Remarks"];
        if (invalidValues.includes(makerRemarksValue?.toString().trim().toUpperCase())) {
            isMakerRemarksMissing = true;
        }

        const missingPrimaryKey = [];
        for (const field of primaryKeyFields) {
            const value = rowData[field.columnName];
            if (invalidValues.includes(value?.toString().trim())) {
                missingPrimaryKey.push(field.columnLabel);
            }
        }

        const totalMissing = [...missingMandatory, ...missingPrimaryKey];
        if (isMakerRemarksMissing) {
            totalMissing.push(makerRemarksField.columnLabel);
        }

        if (totalMissing.length > 0) {
            const formattedFields = totalMissing
                .map(
                    (field, index) =>
                        `<span class="text-warning" style="font-size:14px; font-family:verdana">${field}${index < totalMissing.length - 1 ? ',' : ''}</span>`
                )
                .join(' ');
            const message = `<span style="color: rgba(255, 193, 7, 1); font-size:14px; font-family:verdana;">⚠️ The following fields are missing:</span><br/>${formattedFields}`;
            showMessageModal(message, 'warning');
            return;
        }

        // Valid → Proceed
        handleNotifyPriority(rowIndex);
        setEditingIndexBDm(null);
    };


    const showMessageModal = (message, type) => {
        setModalMessage(message);
        setMessageType(type);
    };


    const handleCancel = async () => {

        try {
            // await fetchData();
            // await fetchFormStructureAndData(param, activeTab);
            const isPast = selectedFullTableName.endsWith('_retrieved');
            const baseTableName = selectedFullTableName.replace(/_(retrieved|live)$/, '');

            await fetchFormStructureAndData(baseTableName, activeTab, isPast);

            setEditingIndex(null); // Clear editing mode after fetching data
            setEditingIndexBDm(null);
        } catch (error) {
            console.error("Error during cancel operation:", error);
            setAlertMessage("Failed to fetch data. Please try again.");
            setShowAlert(true);
        }
    };

    const handleNotifyPriority = (rowIndex) => {
        if (notificationType) {
            handleSaveWithNotification(notificationType, rowIndex);
        } else {
            console.error('No notification type selected');
        }
    };

    const handleSaveWithNotification = async (notificationType, rowIndex) => {
        try {
            const rowId = tableData[rowIndex].rowId;
            const flag = tableData[rowIndex].flag;
            const tableNameWithJson = `${selectedName}.json`;
            const updatedRow = { ...tableData[rowIndex] };
            // const { created_by, created_dt, modified_dt, modified_by, ...dataToUpdate } = updatedRow;
            const { created_by, created_dt, modified_dt, modified_by, approved_dt, approved_by, ...dataToUpdate } = updatedRow;

            const content = JSON.stringify([dataToUpdate], null, 2);
            console.log('Content to update:', content);
            const updateConfig = {
                headers: {
                    userId: localStorage.getItem('userid'),
                    'x-csrf-token': csrfToken,
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            };

            // const responseFile = await axios.post('http://172.16.119.156:3001/update-text-file', { tableNameWithJson, content });
            const responseFile = await axios.post(updatetextfile3001, { tableNameWithJson, content }, updateConfig);
            
            console.log('Text file update response:', responseFile.data);

            const config = {
                headers: { "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken },
                withCredentials: true,
                params: { "filePath": `/saswork/nas/${tableNameWithJson}`, "Notifications": "IN", "dataModel": "BDM", "tableName": selectedName, "dept": Prefix }
            };


            const config1 = {
                headers: { "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken },
                withCredentials: true,
                params: { "rowId": rowId, filePath: `/saswork/nas/${tableNameWithJson}`, "Notifications": "IN", "dataModel": "BDM", "tableName": selectedName, "dept": Prefix }
            };

            let responseDb;

            // const responseDb = await axios.post('http://172.16.119.156:8081/api/updatedata/dem', {}, config);

            if (flag === 'R') {
                responseDb = await axios.post(makermodifypastdata, {}, config1);
            } else {
                responseDb = await axios.post(modifypastdata, {}, config);
            }
            console.log("responsedata Of bdm", responseDb);


            if (responseDb.data && responseDb.data.active_status && responseDb.data.template_type) {
                localStorage.setItem("active_status", responseDb.data.active_status);
                localStorage.setItem("template_type", responseDb.data.template_type);
                localStorage.setItem("stage", responseDb.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: responseDb.data.active_status,
                    template_type: responseDb.data.template_type,
                    stage: responseDb.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }


            if (responseDb.data && responseDb.data.message === 'Data Updated Successfully' || 'Data updated successfully') {
                console.log("first if block!", responseDb.data.message);
                setModalMessage(responseDb.data.message);
                setMessageType('success');
                setShowModal(true);
            } else if (responseDb.data.message) {
                console.log("else if block", responseDb.data.message);
                setModalMessage(responseDb.data.message);
                setMessageType('danger');
                setShowModal(true);

            } else {
                setModalMessage("Failed to create the new file");
                setShowModal(true);
                setMessageType('danger');
            }
        } catch (error) {
            console.error('Error saving data:', error.message);
            setModalMessage('Error saving data');
            setShowModal(true);
            setMessageType('danger');
        }
    };



    const handleRecordsPerPageChange = (e) => {
        setRecordsPerPage(Number(e.target.value)); // Update recordsPerPage state
        setCurrentPage(1); // Reset to the first page
    };



    // reporting date
    useEffect(() => {
        if (reportingDate) {
            const filtered = tableData.filter(item => {
                const itemDate = formatDate(item.reporting_date); // <-- assuming this is the correct field
                return itemDate === reportingDate;
            });
            setReportingFilteredData(filtered);
        } else {
            setReportingFilteredData(tableData);
        }
    }, [reportingDate, tableData]);


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-clock-history me-2"></i>Modify Historical Data
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            {/* <div className="gapsybdmupload-page"> */}
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className={`row m-2 rounded-1 ${styles.cardBorder}`}>
                            <div className={`col-lg-12 col-md-12`}>
                                {/* Tabs */}
                                <div className={tabStyles.tabContainer}>
                                    <div
                                        className={`${tabStyles.tab} ${activeTab === 'manual' ? tabStyles.activeTab : ''}`}
                                        onClick={() => handleTabChange('manual')}
                                    >
                                        <i className="bi bi-pencil-square me-1"></i> Quick Entry
                                    </div>
                                    <div
                                        className={`${tabStyles.tab} ${activeTab === 'bulkUpload' ? tabStyles.activeTab : ''}`}
                                        onClick={() => handleTabChange('bulkUpload')}
                                    >
                                        <i className="bi bi-pencil-square me-1"></i> Bulk Upload
                                    </div>
                                </div>

                                {activeTab === 'manual' && (
                                    <div className={`row m-2`}>
                                        {/* Header Row with Reporting Date */}
                                        <div className={`d-flex justify-content-between align-items-center pb-1 mb-2 ${styles.borderBottom}`}>
                                            <h6 className="mb-0">
                                                Modify Historical Data
                                                {selectedName ? `: ${selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}` : ''}
                                            </h6>
                                            {showSearchInput && (
                                                <div className="d-flex align-items-center ms-3">
                                                    {/* Records Per Page Selector */}
                                                    <div className="me-3">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={recordsPerPage}
                                                            onChange={handleRecordsPerPageChange}
                                                            style={{ width: '70px' }}
                                                        >
                                                            <option value="5">5</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select>
                                                    </div>

                                                    {/* Search Box */}
                                                    <div>
                                                        <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-flex gap-2 align-items-center">
                                                {/* Reporting Date Picker - Same as first example */}
                                                <div className="d-flex align-items-center me-2" style={{ gap: '8px' }}>
                                                    <label
                                                        htmlFor="reportingDate"
                                                        className="form-label mb-0 me-1"
                                                        style={{
                                                            fontSize: '12px',
                                                            color: '#000',
                                                            fontWeight: '500',
                                                            whiteSpace: 'nowrap',
                                                            lineHeight: '1.2'
                                                        }}
                                                    >
                                                        Reporting Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        id="reportingDate"
                                                        value={reportingDate}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === "") {
                                                                setReportingDate("");
                                                                setReportingFilteredData(tableData);
                                                            } else {
                                                                setReportingDate(value); // value is already in 'YYYY-MM-DD'
                                                            }
                                                        }}
                                                        style={{
                                                            width: '140px',
                                                            fontSize: '12px'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`col-lg-4 col-md-12 ${styles.verticalDivider}`}>
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <div>
                                                    <DepartmentDropdown
                                                        selectedPrefix={selectedPrefix}
                                                        setSelectedPrefix={setSelectedPrefix}
                                                        prefixes={prefixes}
                                                    />
                                                </div>

                                                {/* Search Bar */}
                                                <div className="flex-grow-1">
                                                    <Listoftablesearchbox1
                                                        searchQuery={searchQuery}
                                                        onSearchChange={handleSearchChange}
                                                    />
                                                </div>
                                            </div>

                                            <TableRetrievalListGapsy
                                                currentRecords={currentRecords1}
                                                ListofTableFontsize={ListofTableFontsize}
                                                handleTableClick={handleTableClick}
                                                currentPage={currentPage1}  // Pass currentPage
                                                recordsPerPage={recordsPerPage1}  // Pass recordsPerPage
                                                showPastTablesOnly={showPastTablesOnly}
                                                handleTogglePastTables={handleTogglePastTables}
                                                selectedTableName={selectedtableName}
                                            />
                                            {/* </div> */}

                                            {/* </div> */}
                                            {sortedRecords1.length > recordsPerPage1 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage1}
                                                    totalPages={totalPages1}
                                                    paginate={paginate1}
                                                    recordsPerPage={recordsPerPage1}
                                                    tableNames={sortedRecords1} // ← pass sorted list
                                                />
                                            )}

                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            <TemplatetablelistTableStructure
                                                loading={loading}
                                                error={error}
                                                currentItems={currentItems}
                                                columnsToDisplay={columnsToDisplay}
                                                handleEdit={handleEdit}
                                                handleDelete={handleDelete}
                                                isLiveTable={isLiveTable}
                                            // handlecounter={handlecounter}
                                            />

                                            {filteredData.length > 5 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage}
                                                    totalPages={totalPages2}
                                                    paginate={paginate}
                                                    recordsPerPage={recordsPerPage}
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                                {activeTab === 'bulkUpload' && (
                                    <div className={`row m-2`}>
                                        {/* <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify Rejected Data {selectedName ? `: ${selectedName}` : ''}</h6> */}
                                        <div className={`d-flex justify-content-between align-items-center pb-1 mb-2 ${styles.borderBottom}`}>
                                            <h6 className="mb-0">
                                                Modify Approved Data
                                                {selectedName ? `: ${selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}` : ''}
                                            </h6>
                                            {showSearchInput && (
                                                <div className="d-flex align-items-center ms-auto">
                                                    {/* Records Per Page Selector */}
                                                    <div className="me-3">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={recordsPerPage}
                                                            onChange={handleRecordsPerPageChange}
                                                            style={{ width: '70px' }}
                                                        >
                                                            <option value="5">5</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select>
                                                    </div>

                                                    {/* Search Box */}
                                                    <div>
                                                        <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="d-flex gap-2 align-items-center">
                                                {/* Reporting Date Picker with Enhanced Label Styling */}
                                                <div className="d-flex align-items-center me-2" style={{ gap: '8px' }}>
                                                    <label
                                                        htmlFor="reportingDate"
                                                        className="form-label mb-0 me-1"
                                                        style={{
                                                            fontSize: '12px',
                                                            color: '#000',
                                                            fontWeight: '500',
                                                            whiteSpace: 'nowrap',
                                                            lineHeight: '1.2'
                                                        }}
                                                    >
                                                        Reporting Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control form-control-sm"
                                                        id="reportingDate"
                                                        value={reportingDate}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === "") {
                                                                setReportingDate("");
                                                                setReportingFilteredData(tableData);
                                                            } else {
                                                                setReportingDate(value); // no formatDate
                                                            }
                                                        }}
                                                        style={{
                                                            width: '140px',
                                                            fontSize: '12px'
                                                        }}
                                                    />

                                                </div>
                                                {/* Dropdown Download Button */}
                                                <div
                                                    className="custom-dropdown position-relative"
                                                    onMouseEnter={() => selectedName && setShowDropdown(true)}
                                                    onMouseLeave={() => selectedName && setShowDropdown(false)}
                                                >


                                                    {showDropdown && selectedName && (
                                                        <ul className="dropdown-menu show text-start">
                                                            {textFileFormats.map((format) => (
                                                                <li key={format}>
                                                                    <button
                                                                        className="custom-dropdown-item"
                                                                        onClick={() => handleFormatSelect(format)}
                                                                    >
                                                                        .{format}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>

                                            </div>
                                        </div>


                                        <div className={`col-lg-4 col-md-12 ${styles.verticalDivider}`}>
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <div>
                                                    <DepartmentDropdown
                                                        selectedPrefix={selectedPrefix}
                                                        setSelectedPrefix={setSelectedPrefix}
                                                        prefixes={prefixes}
                                                    />
                                                </div>

                                                {/* Search Bar */}
                                                <div className="flex-grow-1">
                                                    <Listoftablesearchbox1
                                                        searchQuery={searchQuery}
                                                        onSearchChange={handleSearchChange}
                                                    />
                                                </div>
                                            </div>


                                            <TableRetrievalListGapsy
                                                currentRecords={currentRecords1}
                                                ListofTableFontsize={ListofTableFontsize}
                                                handleTableClick={handleTableClick}
                                                currentPage={currentPage1}
                                                recordsPerPage={recordsPerPage1}
                                                showPastTablesOnly={showPastTablesOnly}
                                                handleTogglePastTables={handleTogglePastTables}
                                                selectedTableName={selectedtableName}  // Add this prop
                                            />




                                            {/* </div> */}
                                            {sortedRecords1.length > recordsPerPage1 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage1}
                                                    totalPages={totalPages1}
                                                    paginate={paginate1}
                                                    recordsPerPage={recordsPerPage1}
                                                    tableNames={sortedRecords1} // ← pass sorted list
                                                />
                                            )}

                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            <TemplatetablelistTableStructure1
                                                loading={loading}
                                                error={error}
                                                currentItems={currentItems}
                                                columnsToDisplay={columnsToDisplay}
                                                columnDetails={formStructure?.details || []}
                                                handleEditBDM={handleEditBDM}
                                                handleEdit={handleEdit}
                                                handleDelete={handleDelete1}
                                                handleInputChange={handleInputChange}
                                                handleSave={handleSave}
                                                handleCancel={handleCancel}
                                                handleDeleteClick={handleDeleteClick}
                                                editingIndexBDm={editingIndexBDm}
                                                totalPages={totalPages1}
                                                currentPage={currentPage}
                                                paginate={paginate}
                                                primaryKeyFields={primaryKeyFields}
                                                isLiveTable={isLiveTable}
                                            />

                                            {filteredData.length > 5 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage}
                                                    totalPages={totalPages2}
                                                    paginate={paginate}
                                                    recordsPerPage={recordsPerPage}
                                                />
                                            )}


                                        </div>
                                    </div>
                                )}
                            </div>

                            <Modal show={modalMessage} onHide={() => setModalMessage('')} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107' }}></span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                fontSize: '14px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                            dangerouslySetInnerHTML={{ __html: modalMessage }}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseModal}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>

                            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                <Modal.Header style={{
                                    backgroundColor: '#366872',
                                    color: 'white',
                                    padding: '0.5rem 1rem'
                                }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Edit</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    <p>Are you sure you want to Edit this record?</p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant='secondary' onClick={() => setShowEditModal(false)}>Cancel</Button>
                                    <Button variant="primary"
                                        onClick={confirmEdit}>Confirm</Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showConfirmApproveModal} onHide={() => setShowConfirmApproveModal(false)} backdrop="static" keyboard={false}
                                style={{ marginTop: '12vh' }}>
                                <Modal.Header style={{
                                    backgroundColor: '#366872',
                                    color: 'white',
                                    padding: '0.5rem 1rem'
                                }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                >
                                    <p>Are you sure you want to Delete this record?</p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary" onClick={() => setShowConfirmApproveModal(false)}>Cancel</Button>
                                    <Button variant="primary" onClick={() => confirmDelete()}>Confirm</Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showConfirmDeleteModal} onHide={() => setShowConfirmDeleteModal(false)} keyboard={false}
                                style={{ marginTop: '12vh' }}>
                                <Modal.Header style={{
                                    backgroundColor: '#366872',
                                    color: 'white',
                                    padding: '0.5rem 1rem'
                                }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                >
                                    <p>Are you sure you want to Delete this record?</p></Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>

                                    <Button variant="secondary" onClick={() => setShowConfirmDeleteModal(false)}>Cancel</Button>

                                    <Button variant="primary" onClick={() => confirmDelete1()}>Confirm</Button>
                                </Modal.Footer>
                            </Modal>
                        </div>

                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default GapsyApproveTablelist;
